export const CONTENT_SCHEMA = {
  text: {
    text: {
      label: 'Text',
      type: 'textarea',
    },
  },

  image: {
    src: {
      label: 'Image URL',
      type: 'text',
    },
    alt: {
      label: 'Alt text',
      type: 'text',
    },
  },
};
